import { Form, Button } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

interface Props {
  onChange: (value: string) => void;
  onBlur: () => void;
  onMax: () => void;
  value: string;
}

const PaymentCurrencyInput = ({ onChange, onBlur, onMax, value }: Props) => {
  return (
    <>
      <CurrencyInput
        allowNegativeValue={false}
        style={{ background: 'var(--yellow-1)' }}
        className="form-control d-inline"
        decimalsLimit={2}
        decimalScale={2}
        defaultValue={0}
        onValueChange={value => onChange(value || '0')}
        onBlur={onBlur}
        prefix="$"
        value={value}
      />
      <div className="input-toolbar-wrapper">
        <div className="input-toolbar">
          <Button style={{ fontSize: '10px' }} className="btn-xs" onClick={onMax} variant="default">
            Max
          </Button>
        </div>
      </div>
    </>
  );
};

export default PaymentCurrencyInput;
